# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://jashkenas.github.com/coffee-script/
window.NestedFormEvents::insertFields = (content, assoc, link) ->
  $tr = $(link).closest("tr")
  $(content).insertBefore $tr

$(document).on 'turbolinks:load', ->
#  $('select#product_id').selectize();
  $(".tooltip-focus").tooltip selector: "a[data-toggle=tooltip]"
  order_recalc = ->
    list_pcs = $("[id$=_pcs]:visible")
    list_price = $("[id$=_price]:visible")
    list_tax = $("[id$=_tax]:visible")
    i = 0
    total = 0
    while i < list_pcs.length
      total = total + parseFloat(list_pcs.eq(i).val()) * parseFloat(list_price.eq(i).val()) # * (parseFloat(list_tax.eq(i).val()) / 100 + 1)
      i++

    if $("#order_currency_id").val() == '1'
      $("input#order_total").val Math.round(total)
    else
      $("input#order_total").val total.toFixed(2)

  order_recalc()

  $modal_order_email = $('#order-email-modal')
  $('#btn-send-order-email').click ->
    $modal_order_email.modal('hide')
    return

  $('#btn-cancel-order-email').click ->
    $modal_order_email.modal('hide')
    $modal_order_email.find('#client-name').html('')
    $modal_order_email.find('#order_id').val('')
    return

  $('.btn-order-email').click ->
    $modal_order_email.modal('show')
    order_id = $(this).closest('.btn-order-email').data('order-id')
    client_name = $(this).closest('.btn-order-email').data('client-name')
    $modal_order_email.find('#client-name').html("Text message to " + client_name)
    $modal_order_email.find('#order_id').val(order_id)

  $modal_order_sms = $('#order-sms-modal')
  $('#btn-send-order-sms').click ->
    $modal_order_sms.modal('hide')
    return

  $('#btn-cancel-order-sms').click ->
    $modal_order_sms.modal('hide')
    $modal_order_sms.find('#client-name').html('')
    $modal_order_sms.find('#order_id').val('')
    return

  $('.btn-order-sms').click ->
    $modal_order_sms.modal('show')
    order_id = $(this).closest('.btn-order-sms').data('order-id')
    client_name = $(this).closest('.btn-order-sms').data('client-name')
    $modal_order_sms.find('#client-name').html("Text message to " + client_name)
    $modal_order_sms.find('#order_id').val(order_id)

  if $("#order_source_id").val() != undefined

    $("#order_order_date").datetimepicker({timeFormat: 'HH:mm', language: 'cs-CZ', dateFormat: "yy-mm-dd"})

    set_source = ->
      list = $("[id$=_product_name]:visible")
      i = 0
      id = $("#order_source_id").val()
      while i < list.length
        list.eq(i).attr("data-autocomplete", "/document_items/autocomplete_product_name?source_id=" + id)
        list.eq(i).attr("data-id-element", "#" + list.eq(i).next("input[type=hidden]").attr("id"))
        i++

    set_events = ->
      list = $("[id$=_product_name]:visible[id^=order]")
      i = 0
      while i < list.length
        list.eq(i).bind "railsAutocomplete.select", (event, data) ->
          if data.item.id == "19" or data.item.id == "30023" or data.item.id == "40900" or data.item.id == "42426" # Zasilkovna - enable delivery place
            $(event.target).parents("td").next().children(".place_id").removeAttr("disabled").val("")
            switch data.item.id
              when "19"
                $(event.target).parents("td").next().children(".place_id").attr("data-autocomplete", "/document_items/autocomplete_place_name?delivery_id=3")
              when "30023"
                $(event.target).parents("td").next().children(".place_id").attr("data-autocomplete", "/document_items/autocomplete_place_name?delivery_id=23")
              when "40900"
                $(event.target).parents("td").next().children(".place_id").attr("data-autocomplete", "/document_items/autocomplete_place_name?delivery_id=33")
              when "42426"
                $(event.target).parents("td").next().children(".place_id").attr("data-autocomplete", "/document_items/autocomplete_place_name?delivery_id=7")
          else
            $(event.target).parents("td").next().children(".place_id").attr("disabled", "disabled")
            $(event.target).parents("td").next().children(".place_id").val(data.item.plu)
        i++
    $(document).on "nested:fieldAdded", (event) ->
      field = event.field
      calcField = field.find(".calc")
      calcField.keyup ->
        fix_input($(this))
        order_recalc()
      $("[id$=_product_name]:visible[id^=order]:last").focus()
      set_events()
      set_source()

    $(document).on "nested:fieldRemoved", (event) ->
      order_recalc()
    # Kontrola zda zasilkovna ma vyplnene misto
    $('.order-form').on "submit", (event) ->

      products = $('.product_id')
      result = true
      products.each ->
        product_id = $(this).siblings('input').eq(0).val()
        place = $(this).parents('tr').find('.place_id')
        if (product_id == '19' or product_id == '30023' or product_id == '40900' or product_id == '42426') && !place.val()
          alert('Vyberte pobočku dopravce na kterou má být objednávka doručena!')
          place.parents('td').addClass('error')
          place.focus()
          result = false
        else
          place.parents('td').removeClass('error')
      return result


    $("input.calc").keyup ->
      fix_input($(this))
      order_recalc()

    $("#order_currency_id").bind "change", (event, data) ->
      order_recalc()

    $("#order_source_id").bind "change", (event, data) ->
      set_source()

    $("#dodaci_cb").click ->
      $("#dodaci").toggleClass("skryte")


    set_events()
    set_source()

    # COD & diff_currency
    $("div.order_second_currency, div.order_total_2").hide()

    currency_id = 0
    set_currency = ->
      currency_id = $("#order_currency_id option:selected").val()

    cod = (human) ->
      if $("#order_cod").prop('checked')
        $("div.order_second_currency").show()
        if human
          $("#order_second_currency_id option[value=" + currency_id + "]").prop('selected', true)
      else
        $("#order_second_currency_id option[value=" + currency_id + "]").prop('selected', true) # IMPORTANT
        $("div.order_second_currency, div.order_total_2").hide()

    second_currency = ->
      second_currency_id = $("#order_second_currency_id option:selected").val()
      second_currency_name = $("#order_second_currency_id option:selected").text()
      if currency_id != second_currency_id
        $("div.order_total_2").show()
        $("div.order_total_2").find('label').html('<abbr title="povinné">*</abbr> Celkem v ' + second_currency_name)
      else
        $("#order_total_2").val('')
        $("div.order_total_2").hide()


    $("#order_currency_id").bind "change", (event, data) ->
      set_currency()
      second_currency()

    $("#order_cod").bind "change", (event, data) ->
      cod(true)

    $("#order_second_currency_id").bind "change", (event, data) ->
      second_currency()

    set_currency()
    cod(false)
    second_currency()

    fix_input = (t) ->
      a = t.val()
      a = a.replace(/,/g, '.')
      a = a.replace(/\+/g, '1')
      a = a.replace(/ě/g, '2')
      a = a.replace(/š/g, '3')
      a = a.replace(/č/g, '4')
      a = a.replace(/ř/g, '5')
      a = a.replace(/ž/g, '6')
      a = a.replace(/ý/g, '7')
      a = a.replace(/á/g, '8')
      a = a.replace(/í/g, '9')
      a = a.replace(/é|o/g, '0')
      a = a.replace(/\ |a|b|c|d|e|f|g|h|i|j|k|l|m|n|p|q|r|s|t|u|v|w|x|y|z/g, '')
      t.val a
      return

